import React from 'react'
import { ProfileV4DTO } from '@west-australian-newspapers/publication-types'

import { TheWestProfile } from '../../content/Profile/TheWestProfile'
import { PerthNowProfile } from '../../content/Profile/PerthNowProfile'
import { SevenNewsProfile } from '../../content/Profile/SevenNewsProfile'
import { ThemedRender } from '../../__styling/themed-render'
import { createRegisterableComponent } from '@news-mono/web-common'

export interface ProfileRouteProps {
    profileUrl: string
    profile: ProfileV4DTO
}

export const ProfileRegistration = createRegisterableComponent(
    'profile',
    ({ profileUrl, profile }: ProfileRouteProps) => {
        const profileProps = { profile: profile, profileUrl }

        return (
            <ThemedRender
                perthnow={() => <PerthNowProfile {...profileProps} />}
                sevennews={() => <SevenNewsProfile {...profileProps} />}
                thewest={() => <TheWestProfile {...profileProps} />}
            />
        )
    },
)
